import { ca } from '@cian/analytics';

import { TUser } from '../../types/user';
import { TProduct } from '../../types/analytics';
import { IJsonQuery } from '../сonnectToDescriptors';

interface ITrackPageViewCollectParams {
  user: TUser;
  products: TProduct[];
}

export const trackPageViewCollect = ({ user, products }: ITrackPageViewCollectParams) => {
  return ca('event', {
    category: 'seen_label',
    action: 'show_sopr',
    name: 'oldevent',
    page: {
      pageType: 'ListingJK',
      siteType: 'desktop',
    },
    user: user.isAuthenticated ? { userId: user.id } : {},
    products,
  });
};

interface ITrackOfferShowParams {
  jsonQuery: IJsonQuery;
  newbuildingId: number;
  position: number;
  total: number;
  queryString: string;
}

/**
 * Показ ЖК в каталоге
 *
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1490833812
 */
export const trackOfferShow = ({ jsonQuery, newbuildingId, position, total, queryString }: ITrackOfferShowParams) => {
  ca('teaser', {
    sc: jsonQuery,
    product: {
      id: newbuildingId,
      name: 'show_card',
      position,
      screen: 'ListingJK',
      block: 'Listing_snippet',
      extra: {
        offerType: 'JK',
      },
    },
    page: {
      type: 'ListingJK',
      listingType: 'list',
      pageNumber: jsonQuery.page || 1,
      offersQty: total,
      queryString,
    },
  });
};

interface ITrackOfferClickParams {
  newbuildingId: number;
  position: number;
}

/**
 * Клик по ЖК в каталоге
 *
 * @see https://conf.cian.tech/pages/viewpage.action?pageId=1490833812
 */
export const trackOfferClick = ({ newbuildingId, position }: ITrackOfferClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingJK',
    action: 'click_cardjk',
    label: 'cardjk_detail',
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
        position,
      },
    ],
  });
};
